import { useState } from 'react';

const useStore = (defaultValue = [], storageKey = 'todo-data') => {
    // localStorage.removeItem('todo')
    const localData = localStorage.getItem(storageKey);
    const [data, setData] = useState(localData ? JSON.parse(localData) : defaultValue);

    const setLocalData = (newData) => {
        if(newData !== undefined) {
            setData(newData)
            localStorage.setItem(storageKey, JSON.stringify(newData));
        }
        
    };

    return [data, setLocalData];
};

export default useStore;